export default __webpack_public_path__ + "static/media/crypto_coders.ba7238de.png";